import React, { FC, useEffect, useState } from 'react';
import { Column, Container, Grid } from '@goldbely/explore-component-library';
import cls from 'classnames';

import BreakpointsService from 'src/explore/services/breakpoints';
import LogIn from 'src/prize/scenes/LogIn';
import { IMerchant, INavItem } from 'src/prize/types/shoppe';

import Logo from '../../../../atoms/Logo';
import MobileMenuToggle from '../../../../atoms/MobileMenuToggle';
import SearchAndCart from '../../../../molecules/SearchAndCart';
import Links from './molecules/Links';

import styles from './index.module.sass';

interface SouthsideMarketProps {
  links?: INavItem;
  merchant: IMerchant;
}

const SouthsideMarket: FC<SouthsideMarketProps> = ({
  links,
  merchant: { domain, logoImageUrl, name },
}) => {
  const [ overlayLinks, setOverlayLinks ] = useState( false );
  const [ overlaySearch, setOverlaySearch ] = useState( false );
  const isMobile = BreakpointsService.lessThan( 'sm' );

  const handleClickMenuToggle = () => {
    setOverlaySearch( false );
    setOverlayLinks(( state ) => !state );
  };

  const handleClickSearchToggle = () => {
    setOverlayLinks( false );
    setOverlaySearch(( state ) => !state );
  };

  useEffect(() => {
    const handleKeyDown = ( event: KeyboardEvent ) => {
      if ( event.key === 'Escape' ) {
        setOverlayLinks( false );
        setOverlaySearch( false );
      }
    };
    document.addEventListener( 'keydown', handleKeyDown );
    return () => {
      document.removeEventListener( 'keydown', handleKeyDown );
    };
  }, []);

  return (
    <div className={cls( styles.wrap, 'spec__wl-header' )}>
      <Container className={styles.container}>
        <Grid>
          <Column className={styles.content}>
            <div className={`${styles.mobile} ${styles.edge}`}>
              <MobileMenuToggle isActive={overlayLinks} onClick={handleClickMenuToggle} />
            </div>

            <Logo
              className={{ container: styles.logo }}
              image={logoImageUrl}
              link={domain}
              name={name}
            />

            <Links data={links} overlay={overlayLinks} />

            <LogIn className={styles.login} isMobile={isMobile} />

            <div className={styles.edge}>
              <SearchAndCart
                overlaySearch={overlaySearch}
                onClickSearchToggle={handleClickSearchToggle}
              />
            </div>
          </Column>
        </Grid>
      </Container>
    </div>
  );
};

export default SouthsideMarket;
